
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'


export default {
name: 'schoollist',
directives: {
TransferDom
},
components: {
Popup
},
data () {
return {
selectItem: '',
times: 0,
type: 1,
schlist: [],
keyword: '',
backurl: '',
roleType: 0
}
},
computed: {
filterList: function () {
var key = this.keyword
var schlist = this.schlist
if (schlist.length > 0) {
return schlist.filter(function (item) {
return item.value.toLowerCase().indexOf(key.toLowerCase()) !== -1
})
} else {
return ''
}
}
},
created () {
this.getList()
},
methods: {
confirmSelect () {
if (!(this.selectItem.key)) {
this.$vux.toast.text('请先选择院校')
return
}
if (this.type === '2') {
this.$router.push({path: this.backurl, query: {name: this.selectItem.value, id: this.selectItem.key}})
} else {
var params = new URLSearchParams()
params.append('id', this.selectItem.key)
this.$http({
method: 'post',
url: '/scope/select',
data: params
}).then(res => {
if (+res.code === 100) {
this.setCookie('schoolid', this.selectItem.key)
this.$router.push({ path: this.backurl })
} else {
this.$vux.toast.show({
type: 'warn',
text: res.data.result.msg || res.data.result
})
}
}).catch(error => {
console.log(error)
})
}
},
getList () {
this.roleType = this.getCookie('roleType')
this.type = this.$route.query.type || ''






let backurl = this.$route.query.backurl
if (backurl) {
if (backurl.indexOf('callbackurl') > 0 || backurl.indexOf('bindLogin') > 0) {
this.backurl = '/v2todoPage'
} else {
this.backurl = backurl.slice(backurl.indexOf('/h5/') + 3, backurl.length)
}
} else {
this.backurl = '/v2todoPage'
}
if (this.roleType === '1' && this.type === '2') {
this.getCollegeList()
} else if (+this.roleType === 4) {
this.getCollegeList()
} else if (+this.roleType === 3) {
this.getCollegeList()
} else if (+this.roleType === 1) {
this.getSchoolList()
}
},
getSchoolList () {
var params = new URLSearchParams()
params.append('schoolid', this.getCookie('schoolid'))
this.$http({
method: 'post',
url: '/scope',
data: params
}).then(res => {
this.schlist = res.result.list
}).catch(error => {
console.log(error)
})
},
getCollegeList () {
var params = new URLSearchParams()
params.append('schoolid', this.getCookie('schoolid'))
this.$http({
method: 'post',
url: '/dict/college/select',
data: params
}).then(res => {
this.schlist = res.result
}).catch(error => {
console.log(error)
})
}
}
}




// WEBPACK FOOTER //
// ./src/components/schoolList/schoollist.vue